import type { YardiGuestCardRow } from '../types'

/**
 * Show Invite when no automated invite exists (manual invites do not block View).
 */
export function canInviteGuestCard(
  row: Pick<YardiGuestCardRow, 'isAutomatedInvite'>,
): boolean {
  if (row.isAutomatedInvite) return false
  return true
}

/** Validate API marks non-responsible occupants as warning-only and not selectable. */
export function isResponsibleForLease(
  row: Pick<YardiGuestCardRow, 'responsibleForLease'>,
): boolean {
  return row.responsibleForLease !== false
}
